/* User types */

export const USERS_USER_TYPE_VALUE_ADMIN = "admin";
export const USERS_USER_TYPE_VALUE_CUSTOMER = "customer";
